import type { DevScenario } from '@arya/shared/domain';
import type { MockApiErrorBody } from '@arya/shared/msw-cloudflare';
import { devScenarioRequest } from '@arya/shared/msw-cloudflare';

import { http, HttpResponse } from 'msw';

export const PROJECT_DETAIL_FAILURE_SCENARIO: DevScenario = {
  name: 'project-500',
  group: 'Project detail',
  title: 'Server error',
  description: 'The project detail fails to load: error state with a way back to the market.',
  screen: '/market/projects/2',
};

export const projectDetailFailureHandler = http.all(
  devScenarioRequest({ method: 'GET', path: '/api/market/projects/:projectId' }, PROJECT_DETAIL_FAILURE_SCENARIO),
  () => {
    const body: MockApiErrorBody = { error: { message: 'boom' } };
    return HttpResponse.json(body, { status: 500 });
  }
);
